import store from "@/plugins/store";

function Worklist() {
	this.id = 0;
	this.class = "";
	this.name = "";
	this.settings = [];
	this.is_dynamic = true;
	this.owner = {
		id: 0,
		is_admin: false,
		name: ""
	};
	this.acl = null;
	this.details = null;
	this.is_owned = false;

	this.list = function(classname, include_shared, include_hidden) {
		return new Promise((resolve, reject) => {
			// build our url parameters
			let params = new Array();
			params.push("class=" + encodeURIComponent(classname));
			params.push("include_shared=" + include_shared);
			params.push("include_hidden=" + include_hidden);

			// build our url, we have to add url escaping here!
			let url = "/api/worklists";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(d => {
					let json = d.data;

					if (json.status == "OK") {
						// console.log("got data");

						resolve(json.data);
					} else {
						reject(json.reason);
					}
				})
				.catch(e => {
					console.log(e);
					reject(e.message);
				})
		})
	}

	this.create = function() {
		let self = this;

		return new Promise((resolve, reject) => {
			axios
				.post("/api/worklists", {
					id: 0,
					class: self.class,
					name: self.name,
					settings: typeof(self.settings) === 'string' ? self.settings :JSON.stringify(self.settings),
					is_dynamic: self.is_dynamic,
					details: self.details,
				}, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(d => {
					// Don't ask me why it does work here... 
					let json = d.data;

					if (json.status == "OK") {
						// console.log("got data");

						// TODO do we need to do something with the data here?

						resolve(json.data);
					} else {
						reject(json.reason);
					}
				})
				.catch(function(e) {
					console.log(e);
					reject(e.message);
				});
		});
	}

	this.load = function(wl_id) {
		let self = this;

		return new Promise((resolve, reject) => {
			axios
				.get("/api/worklists/" + wl_id, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log("got data");

						// copy our worklist info
						self.id = json.data.id;
						self.class = json.data.class;
						self.name = json.data.name;
						self.settings = json.data.settings;
						self.is_dynamic = json.data.is_dynamic;
						self.owner.id = json.data.owner.id;
						self.owner.is_admin = json.data.owner.is_admin;
						self.owner.name = json.data.owner.name;
						self.details = json.data.details;
						self.acl = json.data.acl;
						self.is_owned = json.data.is_owned;
						self.is_pinned = json.data.is_pinned;

						resolve();
					} else {
						reject(json.reason);
					}
				})
				.catch(function(e) {
					console.log(e);
					reject(e.message);
				});
		});
	}

	this.save = function() {
		let self = this;

		return new Promise((resolve, reject) => {
			axios
				.put("/api/worklists/" +  self.id, {
					id: self.id,
					class: self.class,
					name: self.name,
					settings: typeof(self.settings) === 'string' ? self.settings :JSON.stringify(self.settings),
					is_dynamic: self.is_dynamic,
					details: self.details,
				}, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(d => {
					// Don't ask me why it does work here... 
					let json = d.data;

					if (json.status == "OK") {
						// console.log("got data");

						// TODO do we need to do something with the data here?

						resolve(json.data);
					} else {
						reject(json.reason);
					}
				})
				.catch(function(e) {
					console.log(e);
					reject(e.message);
				});
		});
	}

	this.delete = function() {
		let self = this;

		return new Promise((resolve, reject) => {
			axios
				.delete("/api/worklists/" + self.id, {
				}, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(d => {
					// Don't ask me why it does work here... 
					let json = d.data;

					if (json.status == "OK") {
						resolve();
					} else {
						reject(json.reason);
					}
				})
				.catch(e => {
					console.log(e);
					reject(e.message);
				})
		})
	}
}

export default Worklist;
